// @flow

import type {StatelessFunctionalComponent} from 'react';

import {useEffect} from 'react';
import {Navigate} from 'react-router-dom';

type Props = {
  to: any,
};

export const NoMatch: StatelessFunctionalComponent<Props> = ({to}) => {
  const isInternal = to.startsWith('/');

  useEffect(() => {
    if (!isInternal) {
      window.location.href = to;
    }
  }, [to, isInternal]);

  if (isInternal) {
    return <Navigate to={to} replace />;
  }

  return null;
};
